import React, { useEffect, useState } from "react";
import { Inbox, RefreshCw } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const describe = (s) => {
  if (!s) return "Loading…";
  if (!s.configured) return "Mailbox not connected yet";
  if (!s.last_checked_at) return `Checks every ${s.interval_minutes} min · not run yet`;
  const when = new Date(s.last_checked_at).toLocaleString();
  return s.result === "error" ? `Last check failed · ${when}` : `Last checked ${when} · ${s.imported || 0} imported`;
};

export const InboxStatus = ({ onImported }) => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/inbox/status"); setStatus(data); } catch { setStatus(null); }
  };
  useEffect(() => { load(); }, []);

  const check = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/inbox/check");
      if (data.result === "ok") { toast.success(data.message); if (data.imported) onImported(); }
      else toast.error(data.message);
      load();
    } catch (e) { toast.error(formatError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="text-left sm:text-right flex-1 sm:flex-none min-w-0">
        <div className="flex items-center sm:justify-end gap-1.5 text-[10px] uppercase tracking-widest text-slate-500">
          <Inbox size={12} /> Pre-alert inbox {status?.mailbox ? `· ${status.mailbox}` : ""}
        </div>
        <div data-testid="inbox-status-text" className={`text-xs ${status?.result === "error" ? "text-rose-300" : "text-slate-400"}`}>
          {describe(status)}
        </div>
      </div>
      <Button data-testid="button-check-inbox" variant="outline" onClick={check} disabled={busy}
              className="border-slate-700 hover:bg-slate-800 text-slate-100">
        <RefreshCw size={14} className={`mr-2 ${busy ? "animate-spin" : ""}`} /> Check inbox now
      </Button>
    </div>
  );
};
